export default "__VITE_ASSET__odcyKZEw__"